import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-vb-payments-annual-minimum',
  templateUrl: './vb-payments-annual-minimum.component.html',
  styleUrls: ['./vb-payments-annual-minimum.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VbPaymentsAnnualMinimumComponent {
  @Input() annualMinimum = 0;
  @Input({ required: true }) tooltipText!: string;
  @Input() isEstimated = false;
}
